import { Transition } from '@headlessui/react'
import { i18n } from '@lingui/core'
import { Fragment } from 'react'
import { Logo } from '~/components/Icons/Logo'
import { SpinnerIcon } from '~/components/Icons/Spinner'

export interface FormSubmissionOverlayProps {
  isSubmitting: boolean
}

export const FormSubmissionOverlay = ({ isSubmitting }: FormSubmissionOverlayProps) => {
  return (
    <Transition.Root show={isSubmitting} as={Fragment}>
      <div className="fixed inset-0 z-50">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />
        </Transition.Child>
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="flex flex-col items-center gap-6"
            role="status"
            aria-live="polite"
            aria-busy={isSubmitting}
          >
            <Logo className="h-8 w-auto" />
            <div className="flex flex-col items-center gap-4">
              <SpinnerIcon className="w-12 h-12 text-brand" />
              <p className="text-sm font-medium text-body">
                {i18n._('Daten werden gespeichert...')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Transition.Root>
  )
}
